import React, { createContext, useContext } from 'react';
import { Button, Paper, PaperProps, Tooltip } from '@mui/material';
import { useMakesFormStyles } from './styles';

const ADD_BLOCKED_MESSAGE = 'A recall sync is in progress for this service center';

type TMakesDropdownFooterContext = {
  loading: boolean;
  /** Add is blocked while a recall operation of the service center runs */
  isAddBlocked: boolean;
  onCancel: () => void;
  onAdd: () => void;
};

export const MakesDropdownFooterContext = createContext<TMakesDropdownFooterContext>({
  loading: false,
  isAddBlocked: false,
  onCancel: () => undefined,
  onAdd: () => undefined,
});

/** Autocomplete paper with Cancel / Add footer. Mouse down is prevented to keep the input focused. */
export const MakesDropdownPaper: React.FC<PaperProps> = ({ children, ...props }) => {
  const { classes } = useMakesFormStyles();
  const { loading, isAddBlocked, onCancel, onAdd } = useContext(MakesDropdownFooterContext);

  return (
    <Paper {...props}>
      {children}
      <div className={classes.footer} onMouseDown={e => e.preventDefault()}>
        <Button className={classes.cancelButton} onClick={onCancel}>
          Cancel
        </Button>
        <Tooltip placement="top" title={isAddBlocked ? ADD_BLOCKED_MESSAGE : ''}>
          {/* a disabled button fires no events, so the tooltip listens on the wrapper */}
          <span className={classes.addButtonWrapper}>
            <Button
              variant="contained"
              className={classes.addButton}
              disabled={loading || isAddBlocked}
              onClick={onAdd}
            >
              Add
            </Button>
          </span>
        </Tooltip>
      </div>
    </Paper>
  );
};
